/**
 * Optimized FontAwesome icon configuration
 * Only imports the icons actually used in the package
 */

import { library, type IconDefinition } from '@fortawesome/fontawesome-svg-core';

// Light icons
import { faChevronDown } from '@fortawesome/pro-light-svg-icons';

const lightIcons: IconDefinition[] = [faChevronDown];

// Add all icon arrays to the library
library.add(...lightIcons);
